import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home.vue'
import Features from '@/pages/Features.vue'
import Who from '@/pages/Who.vue'
import Integrations from '@/pages/Integrations.vue'
import HowItWorks from '@/pages/HowItWorks.vue'
import Pricing from '@/pages/Pricing.vue'
import Privacy from '@/pages/Privacy.vue'
import Terms from '@/pages/Terms.vue'
import Contact from '@/pages/Contact.vue'
import Demo from '@/pages/Demo.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'E2M - Easy To Manage'
      }
    },
    {
      path: '/features',
      name: 'Features',
      component: Features,
      meta: {
        title: 'Features - E2M'
      }
    },
    {
      path: '/who',
      name: 'Who',
      component: Who,
      meta: {
        title: 'Who It\'s For - E2M'
      }
    },
    {
      path: '/integrations',
      name: 'Integrations',
      component: Integrations,
      meta: {
        title: 'Integrations - E2M'
      }
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing,
      meta: {
        title: 'Pricing - E2M'
      }
    },
    {
      path: '/how-it-works',
      name: 'HowItWorks',
      component: HowItWorks,
      meta: {
        title: 'How It Works - E2M'
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        title: 'Privacy Policy - E2M'
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: {
        title: 'Terms of Use - E2M'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: 'Contact - E2M'
      }
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo,
      meta: {
        title: 'Schedule a Demo - E2M'
      }
    }
  ],
  scrollBehavior(_, __, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router